import { createFileRoute } from '@tanstack/react-router'
import { guardSetPassword, SetPasswordPage } from '@pa/staff'

/** A-04 (Frontend §5.2): only for a user with a temporary password. */
export const Route = createFileRoute('/set-password')({
  beforeLoad: ({ context }) => guardSetPassword(context),
  component: () => <SetPasswordPage siteName="PF Appointments" />,
})
